import { Injectable } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { AuthHelper } from '@helpers/auth.helper'
import { ModalService } from '@services/modal.service'
import { environment } from '../../environments/environment'
import * as io from 'socket.io-client'
import MainConfig from '../../config/main'
import { RequestServices } from '@services/request.services'
import { AuthService } from '@services/auth.services'
import { CookieService } from 'ngx-cookie-service'
import { Router } from '@angular/router'

@Injectable()
export class SocketService {
    static readonly SW_FILE_PATH = 'assets/js/service-worker.js'
    isSupported: boolean
    private en: any = {}
    private socket: any
    private readonly enableWebsocket: boolean

    constructor(
        private modalService: ModalService,
        private toastrService: ToastrService,
        private requestService: RequestServices,
        private authService: AuthService,
        private cookieService: CookieService,
        private router: Router
    ) {
        this.enableWebsocket = MainConfig.ENABLE_WEBSOCKET
        this.isSupported = SocketService.isPlatformSupportedServiceWorkerAndPushManager()
        this.initializePushNotification()
        // this.performPushWebNotification({
        //     type: 'doctor-reacted',
        //     modalId: '5ef594bfefc7eb1cac46228d',
        //     clinic: '5ef594bfefc7eb1cac46228d',
        //     sender: '5ef594bfefc7eb1cac46228d',
        //     url: `${environment.mainUrl}/app/main/client/edit/5ef594bfefc7eb1cac46228d/communication`
        // });
    }

    static isPlatformSupportedServiceWorkerAndPushManager() {
        return ('PushManager' in window) && ('serviceWorker' in navigator)
    }

    init() {

    }

    initSocket() {
        if (!this.socket && this.enableWebsocket) {
            if(environment.production) {
                this.socket = io('/', {secure: true, rejectUnauthorized: false, path: '/chat/socket.io'})
            } else {
                this.socket = io(environment.baseUrl)
            }
            const that = this
            this.socket.on('connect', function() {
                console.log('socket io connected')
                that.listenSocket()
            })
        }
        return this.socket
    }

    listenSocket() {
        const that = this

        const user = AuthHelper.getUser()
        if (user) {
            this.socket.emit('join clinic', user)
            this.socket.on('communication notice', function (data) {
                data = {
                    ...data,
                    message: `${data.sender} ${that.en[data.type]}`,
                }

                const options = {
                    positionClass: 'toast-bottom-right',
                    disableTimeOut: true,
                    timeOut: 30000,
                    closeButton: true,
                }

                const onTapCallback = function () {
                    that.modalService.emitChange(['showModalChatDetail', data.modalId, true])
                }
                that.showNotificationModal(data, options, onTapCallback)
            })

            //this.socket.on('device_notice', function (data) {
            //    console.log('==============83')
            //    console.log(data)
            //    if (data.clientId === user.clientId) {
            //        console.log('==============87')
            //        localStorage.removeItem('user')
            //        localStorage.removeItem('token')
            //        localStorage.removeItem('timeout')
            //        this.cookieService_.delete('token')
            //        this.router.navigateByUrl('/client/login-token')
            //    }
            //})
        }
    }

    showNotificationModal(data, options, onTapCallback = null) {
        const theme = localStorage.getItem('classThemeBody')
        const modal = this.toastrService.info(data.message, '', {
            ...options,
            toastClass: `toast toast-${ theme || 'blue' }`,
        }).onTap

        return onTapCallback && typeof onTapCallback === 'function' && modal.subscribe(() => onTapCallback())
    }

    emitWebSocketEvent(event, data) {
        if (this.socket) {
            this.socket.emit(event, data)
        }
    }

    /**
     * call this function when we want to push web notification to current clinic
     * @param payload
     */
    performPushWebNotification(payload: IPayload) {
        this.requestService.httpPost('websocket/push-web-notification-to-clinic', { payload })
        .subscribe(result => {
            console.log(result)
        })
    }

    initializePushNotification() {
        if (this.isSupported && MainConfig.ENABLE_WEB_NOTIFICATION) {
            this.registerServiceWorker().then(function(pushSubscription) {
                /**
                 * Received a PushSubscription instance:
                 */

                console.log(pushSubscription)
                const lang = this.authService.getLang() === 'ja' ? 'jp' : 'en'
                console.log('Received PushSubscription: ', JSON.stringify(pushSubscription))

                this.requestService.httpPost('websocket/save-subscription', {
                    subscription: JSON.stringify(pushSubscription),
                    lang,
                })
                .subscribe(result => {
                    console.log('save subscription equal: ', result)
                })
                return pushSubscription
            }.bind(this))
        }
    }

    /**
     * determine the browser that where the service worker file is
     */
    registerServiceWorker() {
        return navigator.serviceWorker.register(SocketService.SW_FILE_PATH)
        .then(function(registration) {
            // if the new worker is not byte-by-byte identical to the current worker,
            // it installs the new worker automatically
            registration.update()
            return registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: this.urlBase64ToUint8Array(
                    environment.vapidPublicKey,
                ),
            })
        }.bind(this))
        .catch(function(err) {
            console.error('Unable to register service worker.', err)
        })
    }

    /**
     * register automatically ask permission, but some scenario, we will need to
     * ask this severally
     */
    askPermission() {
        return new Promise(function(resolve, reject) {
            const permissionResult = Notification.requestPermission(function(result) {
                resolve(result)
            })

            if (permissionResult) {
                permissionResult.then(resolve, reject)
            }
        })
        .then(function(permissionResult) {
            if (permissionResult !== 'granted') {
                throw new Error('We weren\'t granted permission.')
            }
        })
    }

    urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4)
        const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/')

        const rawData = window.atob(base64)
        const outputArray = new Uint8Array(rawData.length)

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i)
        }
        return outputArray
    }
}

interface IPayload {
    type: string,
    modalId: string,
    clinic: string|Object,
    sender: string,
    url?: string
}



// WEBPACK FOOTER //
// ./src/app/services/socket.service.ts